interface TextFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  multiline?: boolean;
}

/** A single short/long text input, labeled. `multiline` renders a textarea
 * instead of an <input> — used for ledes/descriptions rather than headings. */
export function TextField({ label, value, onChange, multiline = false }: TextFieldProps) {
  return (
    <label className="field">
      <span className="field-label">{label}</span>
      {multiline ? (
        <textarea value={value} onChange={(e) => onChange(e.target.value)} rows={3} />
      ) : (
        <input type="text" value={value} onChange={(e) => onChange(e.target.value)} />
      )}
    </label>
  );
}
